import { Fragment } from 'react';

import { rage } from '~/rage';

import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledContainer, StyledShadow } from './Background.styled';

const Background: React.FC = () => {
	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.Dialogs} />
			)}
			<StyledContainer>
				<StyledShadow />
			</StyledContainer>
		</Fragment>
	);
};

export { Background };
